import { Component, HostBinding, Input, OnInit } from '@angular/core';

@Component({
    selector: 'fini-tooltip',
    templateUrl: './tooltip.component.html',
    styleUrls: ['./tooltip.component.scss'],
    host: {
        class: 'tooltip-trigger',
    },
    standalone: false
})
export class TooltipComponent implements OnInit {
  @Input() hFull?: boolean | string = false;

  @HostBinding('class.h-full') get hFullClass() {
    return this.isEnabled(this.hFull);
  }

  constructor() {}
  @Input() close?: boolean | string = false;
  @Input() top?: boolean | string = false;
  @Input() right?: boolean | string = false;
  @Input() left?: boolean | string = false;
  @Input() noClick?: boolean | string = false;

  ngOnInit(): void {}

  isEnabled(value: boolean | string): boolean {
    return typeof value === 'boolean' ? value : value !== 'false';
  }
}
